import React from "react";
import { LegacyCard, ResourceList, ResourceItem, Avatar, Text, LegacyStack, Link } from "@shopify/polaris";
import placeholderImg from "images/placeholder.png";
import type { LinkedLocation } from "../../../api_utils/types";

export function LinkedLocations({
  linkedLocations,
}: {
  readonly linkedLocations: LinkedLocation[];
}): React.JSX.Element {
  const renderLinkedLocationsItem = (shopifyLocation: LinkedLocation) => {
    const shopLocationSettingsPath = `//${shopifyLocation.shopifyDomain}/admin/settings/locations/${shopifyLocation.shopify_location_id}`;
    return (
      <ResourceItem
        external
        id={shopifyLocation.id.toString()}
        key={`${shopifyLocation.id}-linked-location`}
        media={<Avatar customer={false} size="lg" source={placeholderImg} />}
        name={shopifyLocation.name}
        url={shopLocationSettingsPath}
        verticalAlignment="center"
      >
        <LegacyStack distribution="equalSpacing">
          <LegacyStack.Item>
            <Text as="strong">
              <Link monochrome removeUnderline target="_blank">
                {shopifyLocation.name}
              </Link>
            </Text>
            <div>{shopifyLocation.shopifyDomain}</div>
          </LegacyStack.Item>
        </LegacyStack>
      </ResourceItem>
    );
  };

  return (
    <LegacyCard title="Linked locations">
      {linkedLocations?.length ? (
        <ResourceList items={linkedLocations} renderItem={renderLinkedLocationsItem} />
      ) : (
        <LegacyCard.Section>
          <Text as="p" tone="subdued">
            No linked locations
          </Text>
        </LegacyCard.Section>
      )}
    </LegacyCard>
  );
}
